import { PaymentType } from '@ace-clublabs/payment-types';
import React from 'react';
import { Typography } from '@ace-clublabs/shared-component-library';

export interface PaymentHeaderProps {
  paymentType: PaymentType;
  amount: number;
  autoPay?: boolean;
}

const getPaymentTypeHeader = (p: PaymentType): string => {
  switch (p) {
    case PaymentType.CreditOrDebit:
    case PaymentType.DebitOnly:
      return 'Card information';
    case PaymentType.Echeck:
      return 'E-check information';
    default:
      return 'Payment information';
  }
};

const PaymentHeader: React.FC<PaymentHeaderProps> = (props) => {
  return (
    <Typography variant="h5Medium" component="h1" id="payment-form-header">
      {getPaymentTypeHeader(props.paymentType)}
    </Typography>
  );
};

export default PaymentHeader;
